import React from "react"
import {ChartScopeSettings, displayPredefinedChartRange, PredefinedChartRange} from "./chart-scope-settings"

interface ChartScopeButtonsProps {
  chartScopeSettings: ChartScopeSettings
  setChartScopeSettings: (chartScopeSettings: ChartScopeSettings) => void
}

export const ChartScopeButtons: React.FC<ChartScopeButtonsProps> = ({chartScopeSettings, setChartScopeSettings}) => {
  return <ul className="nav nav-pills">
    <li className="nav-item"><PredefinedChartRangeButton predefinedChartRange="lastYear" chartScopeSettings={chartScopeSettings} setChartScopeSettings={setChartScopeSettings} /></li>
    <li className="nav-item"><PredefinedChartRangeButton predefinedChartRange="lastThreeMonths" chartScopeSettings={chartScopeSettings} setChartScopeSettings={setChartScopeSettings} /></li>
    <li className="nav-item"><PredefinedChartRangeButton predefinedChartRange="lastSixMonths" chartScopeSettings={chartScopeSettings} setChartScopeSettings={setChartScopeSettings} /></li>
    <li className="nav-item"><PredefinedChartRangeButton predefinedChartRange="all" chartScopeSettings={chartScopeSettings} setChartScopeSettings={setChartScopeSettings} /></li>
  </ul>
}

interface PredefinedChartRangeButtonProps {
  predefinedChartRange: PredefinedChartRange
  chartScopeSettings: ChartScopeSettings
  setChartScopeSettings: (chartScopeSettings: ChartScopeSettings) => void
}
const PredefinedChartRangeButton: React.FC<PredefinedChartRangeButtonProps> = ({predefinedChartRange, chartScopeSettings, setChartScopeSettings}) => {
  return <button className={"nav-link " + (chartScopeSettings.range === predefinedChartRange ? "active" : "")}
          onClick={() => setChartScopeSettings({...chartScopeSettings, range: predefinedChartRange})}>{displayPredefinedChartRange[predefinedChartRange]}</button>
}